// from https://blog.logrocket.com/how-to-autofocus-using-react-hooks/
import { useCallback } from "react";

const useAutoFocus = (on = []) => {
    const inputRef = useCallback((inputElement) => {
        if (inputElement) {
            setTimeout(function () {
                // Find the first input or textarea descendant and focus it
                const focusableElement = inputElement.querySelector("input, textarea");
                if (focusableElement) {
                    focusableElement.focus();
                }
            }, 0);
        }
    }, on);

    return inputRef;
};

export default useAutoFocus;
